import { disableScroll, enableScroll } from '@util/scrolling';
import { createFocusTrap } from 'focus-trap';

const mainNavWrapper = document.querySelector('#main-nav-wrapper');
const mainNav = document.querySelector('#main-nav');
const mainNavContent = document.querySelector('#main-nav-content');

const isPageBuilder = document.body.classList.contains(
  'KenticoAdminPageBuilder'
);

if (mainNavWrapper && mainNav) {
  let menuIsOpen = false;
  let searchIsOpen = false;

  const openButton = document.querySelector('#menu-toggle');
  const closeButton = mainNavWrapper.querySelector('#close-main-nav');

  const focusTrap = createFocusTrap(mainNavWrapper, {
    initialFocus: mainNav,
    fallbackFocus: mainNav,
    preventScroll: true
  });

  const openMenu = () => {
    menuIsOpen = true;
    mainNavContent?.scrollTo(0, 0);
    mainNavWrapper.classList.add('menu-open', 'initialized');

    disableScroll();

    if (!isPageBuilder) focusTrap.activate();
  };

  const closeMenu = () => {
    menuIsOpen = false;
    mainNavWrapper.classList.remove('menu-open');

    focusTrap.deactivate();
    enableScroll();
    setTimeout(() => openButton?.blur(), 0);
  };

  // Open and close the menu
  openButton?.addEventListener('click', e => {
    e.preventDefault();
    openMenu();
  });

  closeButton?.addEventListener('click', closeMenu);

  mainNavWrapper.addEventListener('click', e => {
    if (!e.target.closest('#main-nav')) closeMenu();
  });

  if (!isPageBuilder) {
    window.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !searchIsOpen) {
        closeMenu();
      }
    });
  }

  let searchOpenTimer;

  window.addEventListener('globalsearchopen', () => {
    clearTimeout(searchOpenTimer);
    searchIsOpen = true;
    if (menuIsOpen) focusTrap.deactivate();
  });

  window.addEventListener('globalsearchclose', () => {
    clearTimeout(searchOpenTimer);

    if (menuIsOpen) {
      focusTrap.activate();

      searchOpenTimer = setTimeout(() => {
        searchIsOpen = false;
      }, 200);
    } else {
      searchIsOpen = false;
    }
  });
}
